// extracted by mini-css-extract-plugin
export var criteriaStripClearButton = "criteria-strip__clear-button_zJxdwDD2GdXOKJc2OLkQ";
export var criteriaStripGroup = "criteria-strip__group_clu0wEaKNAPGZPT6CWny";
export var criteriaStripPill = "criteria-strip__pill_PjSnV6UCxS2wUsXNGcnS";